import { render } from "./GradientButton.vue?vue&type=template&id=34520d56&scoped=true"
import script from "./GradientButton.vue?vue&type=script&lang=js"
export * from "./GradientButton.vue?vue&type=script&lang=js"

import "./GradientButton.vue?vue&type=style&index=0&id=34520d56&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34520d56"]])

export default __exports__